<template>
  <div class="keep-flow_block">
    <!-- 基本信息 -->
    <div class="keep-flow_wrapTitBox">
      <div style="display: flex;align-items: center;">
        <span class="h3">{{ $t('workFlow.txt13') }}</span>
        <div @click="onMnLc" v-if="auto_test_before_post">
          <svg-icon style="width: 100px;margin-left: 3px;display: block;height: auto;"
            icon-class="fewffwerweefeewff"></svg-icon>
        </div>
      </div>
      <div class="upDownBtn">
        <div v-if='$t("workFlow.txt1")' style="display: flex;align-items: center;margin-right: 10px;">
          <van-switch size="16" v-model="isJump"></van-switch>
          <span style="font-size: 16px;margin-left: 5px;" :class="isJump ? 'isJumpActive' : ''"
            @click="isJump = !isJump">{{
              $t("workFlow.txt1") }}</span>
        </div>
        <van-icon size="20" color="#999999" @click="showWrapFun" v-if="showWrapStatus" name="arrow-up" />
        <van-icon size="20" color="#999999" @click="showWrapFun" v-else name="arrow-down" />
      </div>
    </div>
    <div class="keep-flow_container" v-show="showWrapStatus" style="padding-top: 10px;">
      <div class="contentBox">
        <van-steps direction="vertical" :active="active" active-icon="passed" inactive-icon="more-o">
          <van-step v-for="(value, key) in tableData" :key="key" v-show="value.isjump ? isJump : true">
            <template #active-icon>
              <div class="seupActiveIcon" :style="'background:#' + value.app_btn_bgcolor">
                <div>{{ value.empname ? value.empname.slice(0, 1) : '' }}</div>
                <van-icon v-if="value.isreturn" color="red" class="isIcon" name="cross" />
                <van-icon v-else-if="value.ischeck && !value.isreturn" color="green" class="isIcon" name="passed" />
                <van-icon v-else-if="!value.ischeck && !value.isreturn" color="#ff8d2b" class="isIcon" name="more-o" />
              </div>
            </template>
            <template #inactive-icon>
              <div class="seupActiveIcon" :style="'background:#' + value.app_btn_bgcolor">
                <div>{{ value.empname ? value.empname.slice(0, 1) : '' }}</div>
                <van-icon v-if="value.isreturn" color="red" class="isIcon" name="cross" />
                <van-icon v-else-if="value.ischeck && !value.isreturn" color="green" class="isIcon" name="passed" />
                <van-icon v-else-if="!value.ischeck && !value.isreturn" color="#ff8d2b" class="isIcon" name="more-o" />
              </div>
            </template>
            <div class="seupActiveContent">
              <div class="seupActiveContentTop">
                <span></span>
                <div style="display: flex;align-items: center;">
                  <van-button v-if="value.sign_url" @click="ckQmZp(value)"
                    style="margin-right: 5px;width: 20px;height: 20px;" size="mini" icon="search" type="info" />
                  <h3 style="font-weight: bold;" :style="'color:#' + value.app_btn_bgcolor">
                    {{
                      value.itypename
                    }}
                    <van-button v-if="value.ismc" @click="ckNodeHq(value)" style="margin-left: 5px;border-radius: 5px;"
                      size="mini" type="info">查看</van-button>
                  </h3>
                </div>


              </div>
              <div class="seupActiveContentTop">
                <h3 style="font-size: 12px;"><span style="font-weight: bold;color: #000;">{{ value.empname
                    }}</span><span style="color: #666;">（{{ value.ismc ? '会签' : value.staname }}）</span></h3>
                <span>{{ value.crdate }}</span>
              </div>
              <div class="seupActiveContentTop" style="margin-top: 2px;" v-if="value.itype != 2 && value.itype != 1">
                <div style="color: #999;font-size: 12px;">{{ value.checkstatus }}</div>
                <span>{{ value.checkdate }}</span>
              </div>
              <div class="seupActiveContentBody" v-show="value.checkmemo" style="margin-top: 2px;">
                <div class="word">{{ value.checkmemo }}</div>
              </div>
            </div>
          </van-step>
        </van-steps>
        <!-- 如果-0.7rem有问题，改为-10px -->
        <van-button type="info" plain size="small" style="position: relative;top: -0.7rem;border-radius: 5px;"
          @click="ckLsspjl">查看历史审批记录</van-button>
      </div>
      <div class="huise" style="width: 100%;height: 0.42667rem;background: #f6f6f6;"></div>
      <div class="commentRecordContainer"
        style="padding-bottom: 10px;margin: 0.42667rem;margin-top: 0;padding-top: 10px;"
        v-if="formConfig && formConfig.use_flow_comment">
        <van-cell title="评论">
          <template #right-icon>
            <van-icon @click="addCommentFun" name="edit" />
          </template>
        </van-cell>
        <div class="commentRecordList" v-for="(value, key) in commentTableData" :key="key">
          <div class="commentRecordListTop">
            <span style="color: #666;">{{ value.empname }}</span>
            <span style="color: #999;">{{ value.crdate }}</span>
          </div>
          <div class="commentRecordListContent">
            <span>{{ value.comment_msg }}</span>
          </div>
          <div class="commentRecordListImages">
            <van-image v-if="value.pic1_url" width="100" height="100" lazy-load :src="value.pic1_url" fit="contain"
              @click="onImagePreview(value.pic1_url)" />
            <van-image v-if="value.pic2_url" width="100" height="100" lazy-load fit="contain" :src="value.pic2_url"
              @click="onImagePreview(value.pic2_url)" />
            <van-image v-if="value.pic3_url" width="100" height="100" lazy-load fit="contain" :src="value.pic3_url"
              @click="onImagePreview(value.pic3_url)" />
            <van-image v-if="value.pic4_url" width="100" height="100" lazy-load fit="contain" :src="value.pic4_url"
              @click="onImagePreview(value.pic4_url)" />
            <van-image v-if="value.pic5_url" width="100" height="100" lazy-load fit="contain" :src="value.pic5_url"
              @click="onImagePreview(value.pic5_url)" />
            <van-image v-if="value.pic6_url" width="100" height="100" lazy-load fit="contain" :src="value.pic6_url"
              @click="onImagePreview(value.pic6_url)" />
            <van-image v-if="value.pic7_url" width="100" height="100" lazy-load fit="contain" :src="value.pic7_url"
              @click="onImagePreview(value.pic7_url)" />
            <van-image v-if="value.pic8_url" width="100" height="100" lazy-load fit="contain" :src="value.pic8_url"
              @click="onImagePreview(value.pic8_url)" />
            <van-image v-if="value.pic9_url" width="100" height="100" lazy-load fit="contain" :src="value.pic9_url"
              @click="onImagePreview(value.pic9_url)" />
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="addCommentStatus" position="bottom" closeable close-icon-position="top-left">
      <div class="addCommentTitle"
        style="width: 100%;height: 53px;text-align: center;line-height: 53px;font-size: 18px;font-weight: bold;">添加评论
      </div>
      <div class="addCommentContent">
        <textarea v-model="textarea" placeholder="请输入评论（必填）" id="comment_msg"></textarea>
      </div>
      <div class="addCommentContent2">
        <!-- 推荐回复 -->
        <div style="color: #999;font-size: 15px;margin-top: 10px;">推荐回复</div>
        <div class="tjhflist">
          <div class="tjhflistspan" @click="addWord('已阅')">已阅</div>
          <div class="tjhflistspan" @click="addWord('收到')">收到</div>
          <div class="tjhflistspan" @click="addWord('已核对')">已核对</div>
          <div class="tjhflistspan" @click="addWord('合格')">合格</div>
          <div class="tjhflistspan" @click="addWord('情况属实')">情况属实</div>
          <div class="tjhflistspan" @click="addWord('确认')">确认</div>
          <div class="tjhflistspan" @click="addWord('已复核')">已复核</div>
          <div class="tjhflistspan" @click="addWord('知悉')">知悉</div>
          <div class="tjhflistspan" @click="addWord('辛苦了')">辛苦了</div>
          <div class="tjhflistspan" @click="addWord('已安全')">已安全</div>
        </div>
      </div>
      <div class="addCommentContent2">
        <div style="color: #999;font-size: 15px;margin-top: 10px;">附件上传</div>
        <div class="fjsclist" style="margin-top: 10px;">
          <van-uploader v-model="fileList" multiple max-count="9" accept="image/png" :after-read="afterRead" />
        </div>
      </div>
      <div class="addCommentContent2" style="margin-bottom: 12px;">
        <van-button type="info" size="small" block style="border-radius: 5px;" @click="sendComment">发送</van-button>
      </div>
    </van-popup>
    <viewMc ref="refViewMc" :formConfig="formConfig"></viewMc>
    <!-- 历史审批记录 -->
    <van-dialog class="mnlcDialog" v-model="lsspjlShow" cancel-button-text="关闭" show-cancel-button
      :show-confirm-button="false" :before-close="beforeLsspjlClose">
      <div class="contentBox" style="padding: 0;margin-top: 0.6rem;">
        <van-steps direction="vertical" :active="active" active-icon="passed" inactive-icon="more-o">
          <van-step v-for="(value, key) in lsspjlData" :key="key" v-show="value.isjump ? isJump : true">
            <template #active-icon>
              <div class="seupActiveIcon" :style="'background:#' + value.app_btn_bgcolor">
                <div>{{ value.empname ? value.empname.slice(0, 1) : '' }}</div>
                <van-icon v-if="value.isreturn" color="red" class="isIcon" name="cross" />
                <van-icon v-else-if="value.ischeck && !value.isreturn" color="green" class="isIcon" name="passed" />
                <van-icon v-else-if="!value.ischeck && !value.isreturn" color="#ff8d2b" class="isIcon" name="more-o" />
              </div>
            </template>
            <template #inactive-icon>
              <div class="seupActiveIcon" :style="'background:#' + value.app_btn_bgcolor">
                <div>{{ value.empname ? value.empname.slice(0, 1) : '' }}</div>
                <van-icon v-if="value.isreturn" color="red" class="isIcon" name="cross" />
                <van-icon v-else-if="value.ischeck && !value.isreturn" color="green" class="isIcon" name="passed" />
                <van-icon v-else-if="!value.ischeck && !value.isreturn" color="#ff8d2b" class="isIcon" name="more-o" />
              </div>
            </template>
            <div class="seupActiveContent">
              <div class="seupActiveContentTop">
                <span></span>
                <div style="display: flex;align-items: center;">
                  <van-button v-if="value.sign_url" @click="ckQmZp(value)"
                    style="margin-right: 5px;width: 20px;height: 20px;" size="mini" icon="search" type="info" />
                  <h3 style="font-weight: bold;" :style="'color:#' + value.app_btn_bgcolor">
                    {{
                      value.itypename
                    }}
                    <van-button v-if="value.ismc" @click="ckNodeHq(value)" style="margin-left: 5px;border-radius: 5px;"
                      size="mini" type="info">查看</van-button>
                  </h3>
                </div>


              </div>
              <div class="seupActiveContentTop">
                <h3 style="font-size: 12px;"><span style="font-weight: bold;color: #000;">{{ value.empname
                    }}</span><span style="color: #666;">（{{ value.ismc ? '会签' : value.staname }}）</span></h3>
                <span>{{ value.crdate }}</span>
              </div>
              <div class="seupActiveContentTop" style="margin-top: 2px;" v-if="value.itype != 2 && value.itype != 1">
                <div style="color: #999;font-size: 12px;">{{ value.checkstatus }}</div>
                <span>{{ value.checkdate }}</span>
              </div>
              <div class="seupActiveContentBody" v-show="value.checkmemo" style="margin-top: 2px;">
                <div class="word">{{ value.checkmemo }}</div>
              </div>
            </div>
          </van-step>
        </van-steps>
      </div>
    </van-dialog>
    <!-- 模拟流程 -->
    <van-dialog class="mnlcDialog" v-model="mnlcShow" cancel-button-text="关闭" show-cancel-button
      :show-confirm-button="false" :before-close="beforeMnLcClose">
      <van-steps direction="vertical" :active="mnlcActive" active-icon="success" inactive-icon="more-o">
        <van-step v-for="(value, key) in mnlcData" :key="key">
          <template #active-icon>
            <div class="seupActiveIcon">
              <div>{{ value.empname ? value.empname.slice(0, 1) : '' }}</div>
              <van-icon v-if="value.isok" color="green" class="isIcon" name="success" />
              <van-icon v-else color="red" class="isIcon" name="cross" />
            </div>
          </template>
          <template #inactive-icon>
            <div class="seupActiveIcon">
              <div>{{ value.empname ? value.empname.slice(0, 1) : '' }}</div>
              <van-icon v-if="value.isok" color="green" class="isIcon" name="success" />
              <van-icon v-else color="red" class="isIcon" name="cross" />
            </div>
          </template>
          <div class="seupActiveContent">
            <div class="seupActiveContentTop">
              <h3>{{ value.nodeid == 1 ? '发起申请' : '审批人' }}</h3>
            </div>
            <div class="seupActiveContentTop" style="margin-top: 2px;">
              <h3 style="color: #999;font-size: 12px;">{{ value.empname }}（{{ value.empcode }}）</h3>
              <span>{{ value.nodetitle }}</span>
            </div>
            <div class="seupActiveContentBody" style="margin-top: 2px;">
              <div class="word">{{ value.info }}</div>
            </div>
          </div>
        </van-step>
      </van-steps>
    </van-dialog>
  </div>
</template>
<script>
import { Toast, ImagePreview } from 'vant';

import viewMc from "./viewMc.vue";
import {
  getWorkFlowDetail,
  getFlowCommentRecord,
  postFlowComment,
  getWorkFlowTestDetail,
  getHisWorkFlowDetail
} from '@api/workFlow'

export default {
  components: {
    viewMc
  },
  props: {
    // 基本信息
    formConfig: {
      type: Object,
      default: () => { },
    },
    auto_test_before_post: {
      type: Boolean,
      default: false
    },
  },
  data() {
    const userInfo = localStorage.userInfo ? JSON.parse(localStorage.userInfo)
      : this.$route.query.formoutSize == '1' ? { userid: 1, username: 'admin' }// 外部人员打开单据时用到
        : {}
    return {
      userInfo,
      showWrapStatus: true,
      active: 999,
      tableData: [],
      commentTableData: [],
      addCommentStatus: false,
      fileList: [],
      textarea: "",
      isJump: false,
      mnlcShow: false,  // 模拟流程
      mnlcData: [],     // 模拟流程数据
      mnlcActive: 999,
      mnAutoId: null,   // 模拟流程ID
      lsspjlData: [],
      lsspjlShow: false,
    }
  },
  created() {
    this.getDate();
  },
  watch: {
    formConfig(n) {
      if (n) {
        this.isJump = n.show_jump_node
      }
    }
  },
  computed: {
    formname() {
      return this.$route.query.formname
    },
    formautoid() {
      return this.$route.query.formautoid
    },
    mautoid() {
      return this.$route.query.mautoid
    },
    nodeid() {
      return this.$route.query.nodeid
    },
    saveormodify() {
      return this.$route.query.saveormodify
    },
    // 0是没意义的，一般是新增
    // 1：待我审批
    // 2：我发起的
    // 3：我已审批
    // 4：被撤销的
    // 5：未提交的
    // 6：抄送
    documentType() {
      return this.$route.query.documentType || 0
    },
  },
  methods: {
    onMnLc() {
      const loading = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '请求中...',
      });
      getWorkFlowTestDetail({
        formautoid: this.formautoid,
        autoid: this.mautoid,
        username: this.userInfo.username
      }).then(res => {
        loading.clear()
        this.mnlcData = res.data;
        this.mnlcShow = true;
      })
    },
    beforeMnLcClose(action, done) {
      this.mnlcShow = false;
      done();
    },
    async ckLsspjl() {
      const loading = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '请求中...',
      });
      const res2 = await getHisWorkFlowDetail({
        mautoid: this.mautoid,
        formautoid: this.formautoid,
        userid: this.userInfo.userid,
        flag: 1
      })
      this.lsspjlData = res2.data //子表模块配置
      this.lsspjlShow = true;

      loading.clear()
    },
    beforeLsspjlClose(action, done) {
      this.lsspjlShow = false;
      done();
    },
    addWord(str) {
      this.textarea = this.textarea + str
    },
    onImagePreview(val) {
      ImagePreview({
        images: [val],
        className: "windowImagePreviewClassName"
      });
    },
    getDate() {
      if (this.saveormodify != 'save' && this.documentType != 5) {
        getWorkFlowDetail({
          formautoid: this.formautoid,
          mautoid: this.mautoid
        }).then(res => {
          this.tableData = res.data
          if (this.tableData && this.tableData.length > 0) {
            this.$emit("showSpJl", true)
            this.$emit("lastFlowDetailData", this.tableData[this.tableData.length - 1])
            this.getFlowCommentRecordData()
          }
        })
      }
    },
    getFlowCommentRecordData() {

      getFlowCommentRecord({
        formautoid: this.formautoid,
        mautoid: this.mautoid,
        username: this.userInfo.username,
        nodeid: this.nodeid,
      }).then(res => {
        this.commentTableData = res.data;
        // console.log(this.formConfig,'use_flow_comment')
      })

    },
    addCommentFun() {
      this.fileList = [];
      this.textarea = "";
      this.addCommentStatus = true;
    },
    showWrapFun() {
      this.showWrapStatus = !this.showWrapStatus
    },
    afterRead(file) {

    },
    ckNodeHq(node) {
      this.$refs.refViewMc.getMcDetailFun(node);
    },
    loadImage(url, callback) {
      var img = new Image();
      img.onload = function () {
        callback(null, img);
      };
      img.onerror = function () {
        callback(new Error('Could not load image at ' + url), null);
      };
      img.src = url;
    },
    ckQmZp(value) {
      if (value.sign_url) {

        this.loadImage(value.sign_url, function (error, image) {
          if (error) {
            Toast('图片加载出错！')
          } else {
            ImagePreview({
              images: [value.sign_url],
              className: "windowImagePreviewClassName"
            });
          }
        });
      } else {
        Toast('签名照片为空！')
      }
    },
    sendComment() {
      if (!this.textarea) {
        Toast("评论内容不能为空！")
        return;
      }
      const baseUrlArr = []
      if (this.fileList.length > 0) {
        for (let i = 0; i < this.fileList.length; i++) {
          baseUrlArr.push({
            pic: this.fileList[i].content
          })
        }
      }
      postFlowComment({
        nodeid: Number(this.nodeid),
        formautoid: Number(this.formautoid),
        mautoid: this.mautoid,
        username: this.userInfo.username,
        comment_msg: this.textarea,
        data: baseUrlArr
      }).then(res => {
        Toast('评论添加成功！');
        this.addCommentStatus = false;
        this.getFlowCommentRecordData();
      })
    },
  }
}
</script>
<style lang="less" scoped>
.keep-flow_block {
  width: 100%;
  margin-bottom: 25px;
  order: 5;

  .keep-flow_wrapTitBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.42667rem;
    height: 92px;

    background: #fff;

    .h3 {
      color: #333333;
      font-size: 32px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      margin: 0 !important;
      text-align: left;
      font-style: normal;
    }

    .upDownBtn {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.keep-flow_container {

  width: 100%;
  background: #fff;


}

.contentBox {
  padding: 0 0.42667rem;
  margin-top: 12px;

  /deep/.van-hairline {
    padding-top: 0 !important;
    padding-bottom: 50px !important;
  }

  /deep/.van-steps {
    overflow: visible !important;
  }

  /deep/.van-step__title {
    position: relative;
    top: -36px;
  }

  .seupActiveIcon {
    width: 70px;
    height: 70px;
    background: #2B8DF0;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    position: relative;

    div {
      color: #fff;
      text-align: center;
      font-size: 38px;
    }

    .isIcon {
      position: absolute;
      font-size: 24px;
      right: -0.1rem;
      bottom: -0.1rem;
      border-radius: 24px;
      background: #fff;
    }
  }

  .seupActiveContent {
    padding-left: 25px;
    position: relative;

    h3 {
      margin: 0;
    }

    .seupActiveContentTop {
      display: flex;
      justify-content: space-between;
      color: #333;
      align-items: center;

      h3 {
        font-size: 28px;
        color: #111F2C;
        font-weight: 500;
        display: flex;
        align-items: center;
      }

      span {
        color: #A4A5A6;
        font-size: 24px;
      }

      /deep/.van-button__text {
        color: #fff !important;
      }
    }

    .seupActiveContentBody {
      .word {
        font-size: 24px;
        color: #333333;
      }
    }
  }
}

.yspclass {
  color: green;
}

.spzclass {
  color: #bf550a;
}

.ycxclass {
  color: red;
}

.commentRecordContainer {
  /deep/.van-cell {
    padding: 0 !important;
    display: flex;
    align-items: center;

    .van-cell__title {
      span {
        font-weight: bold;
      }
    }
  }

}

.addCommentContent {
  padding: 0 0.29334rem;

  #comment_msg {
    width: 100%;
    border: none;
    height: 300px;
    padding: 0.13333rem;
    resize: none;
    font-size: 28px;
  }

}

.addCommentContent2 {
  padding: 0 0.42667rem;
  margin-top: 20px;
}

.tjhflist {
  display: flex;

  flex-wrap: wrap;

  .tjhflistspan {
    padding: 6px 16px;
    background: #eee;
    color: #333;
    border-radius: 5px;
    margin-right: 22px;
    cursor: pointer;
    font-size: 32px;
    margin-top: 16px;
  }
}

.commentRecordList {
  width: 100%;
  padding-bottom: 12px;
  border-bottom: 1px solid #eee;
  margin-top: 20px;

  .commentRecordListTop {
    width: 100%;
    display: flex;
    justify-content: space-between;
    font-size: 28px;
  }

  .commentRecordListContent {
    width: 100%;
    text-align: justify;
    line-height: 1;

    span {
      font-size: 28px;
    }
  }

}

.commentRecordListImages {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-between;
  margin-top: 15px;

  /deep/.van-image {
    margin-bottom: 15px;
    margin-right: 22px;
  }
}

.isJumpActive {
  color: #1989fa !important;
}

.mnlcDialog {
  height: 90% !important;
  width: 95% !important;
  top: 50% !important;

  /deep/.van-dialog__header {
    display: none !important;
  }

  /deep/.van-dialog__content {
    height: calc(100% - 1.28rem) !important;
    overflow: auto;
    padding: 20px;
  }

  .seupActiveIcon {
    width: 70px;
    height: 70px;
    background: #2B8DF0;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    position: relative;

    div {
      color: #fff;
      text-align: center;
      font-size: 38px;
    }

    .isIcon {
      position: absolute;
      font-size: 24px;
      right: -0.1rem;
      bottom: -0.1rem;
      border-radius: 24px;
      background: #fff;
    }
  }

  .seupActiveContent {
    padding-left: 25px;

    h3 {
      margin: 0;
    }

    .seupActiveContentTop {
      display: flex;
      justify-content: space-between;
      color: #333;
      align-items: center;

      h3 {
        font-size: 28px;
        color: #111F2C;
        font-weight: 500;
      }

      span {
        color: #A4A5A6;
        font-size: 24px;
      }
    }

    .seupActiveContentBody {
      .word {
        font-size: 24px;
        color: #333333;
        word-break: break-all;
      }
    }
  }
}
</style>